import { AuditFilters } from "./types";

export const AUDIT_FILTER_LABELS: Record<keyof AuditFilters, string> = {
  action: "Action",
  outcome: "Outcome",
  user_email: "User email",
  auth_context: "Authentication context",
  resource_type: "Target type",
  resource_name: "Target name",
  group_id: "Group name",
  project_name: "Project name",
  package_name: "Package name",
} as const;

export const AUDIT_FILTER_OVERVIEW_LABELS = {
  ...AUDIT_FILTER_LABELS,
  group_id: "Group ID",
} as const;
